//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/DateBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/DateBuilder.js";
import "../no/DateItemBuilder.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ArrayIndex",1,0],[0,"BooleanValue",1,0],[0,"Category",1,0],[0,"DataType",1,0],[1,"DateValue",0,"DateBuilder",0],[0,"Expression",1,"Expression",0],[0,"IntegerValue",1,0],[0,"IsArray",1,0],[0,"IsReferenceType",1,0],[0,"LockOnSave",1,0],[0,"NumberValue",1,0],[0,"ObjectPicker",1,1],[1,"SelectedObjects",0,"SelectNXObjectList",0],[0,"StringValue",1,0],[0,"Title",1,0],[0,"Units",1,0],[0,"ValueAlias",1,0]],[[["object"],"Delete",{},1,0],[["object"],"DeleteArray",{},1,0],[[],"CreateAttribute",{R_:{changed:''}},0,0],[[],"ApplyUnits",{R_:{changed:''}},0,0],[["objects"],"SetAttributeObjects",{},1,0],[["numValues","values"],"GetStringListOfValues",{},0,0],[["numValues","values"],"GetDoubleListOfValues",{},0,0],[["numValues","values"],"GetIntegerListOfValues",{},0,0],[["numValues","values"],"GetDateListOfValues",{},0,0]],[]];
SPLM.AttributePropertiesBaseBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AttributePropertiesBaseBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AttributePropertiesBaseBuilder.ObjectOptions = Object.freeze({
    "Object" : "Object", "Feature" : "Feature", "Occurrence" : "Occurrence", "ComponentInstance" : "ComponentInstance", "ReferenceSet" : "ReferenceSet", "ObjectInComponentPart" : "ObjectInComponentPart", "ComponentAsPartAttribute" : "ComponentAsPartAttribute", "Empty" : "Empty"});

SPLM.AttributePropertiesBaseBuilder.DataTypeOptions = Object.freeze({
    "Null" : "Null", "Boolean" : "Boolean", "Integer" : "Integer", "Number" : "Number", "String" : "String", "Date" : "Date"});

SPLM.AttributePropertiesBaseBuilder.BooleanValueOptions = Object.freeze({
    "False" : "False", "True" : "True"});

export default SPLM;